import AirPods4 from '../../../assets/apple/iPod/AirPods4.jpeg';
import AirPods4withANC from '../../../assets/apple/iPod/AirPods4withANC.jpeg';
import AirPodsMax from '../../../assets/apple/iPod/AirPodsMax.jpeg';
import AirPodsMaxBlue from '../../../assets/apple/iPod/AirPodsMaxBlue.jpeg';
import AirPodsMaxPurple from '../../../assets/apple/iPod/AirPodsMaxPurple.jpeg';
import AirPodsMaxStarlight from '../../../assets/apple/iPod/AirPodsMaxStarlight.jpeg';
import AirPodsMaxOrange from '../../../assets/apple/iPod/AirPodsMaxOrange.jpeg';
import AirPodsMaxMidnight from '../../../assets/apple/iPod/AirPodsMaxMidnight.jpeg';

export const airpodsProductDetails = [
  {
    id: 1,
    title: 'AirPods 4',
    productImage: AirPods4,
    images: [AirPods4],
    originalPrice: ' 12,900',
    discountedPrice: '11,900',
    // offerText: 'Flat ₹2,901 off',
    colors: ['white'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' No Cost EMI from ₹1,984/month' },
    ],
    specifications: {
      // Audio: 'Active Noise Cancellation, Adaptive Transparency',
      // Battery: 'Up to 6 hours of listening time (30 hours with case)',
      // Controls: 'Touch control for volume, play/pause, and calls',
      // Compatibility: 'Works with iOS, macOS, iPadOS',
      Specs: [
        'H2 Chip',
        'Personalised Spatial Audio',
        'Dynamic Head Tracking',
        'Force Sensor',
        'Up to 5 hours of listening time on one charge',
        'Up to 30 hours of listening time with charging case',
      ],
    },
  },
  {
    id: 2,
    title: 'AirPods 4 with ANC',
    productImage: AirPods4withANC,
    images: [AirPods4withANC],
    originalPrice: ' 17,900',
    discountedPrice: '16,400',
    // offerText: 'Flat ₹2,901 off',
    colors: ['white'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' No Cost EMI from ₹2,734/month' },
    ],
    specifications: {
      // Audio: 'Active Noise Cancellation, Adaptive Transparency',
      // Battery: 'Up to 6 hours of listening time (30 hours with case)',
      // Controls: 'Touch control for volume, play/pause, and calls',
      // Compatibility: 'Works with iOS, macOS, iPadOS',
      Specs: [
        'H2 Chip',
        'Active Noise Cancellation, Adaptive Audio and Transparency mode.',
        'Conversation Awareness',
        'Personalised Spatial Audio',
        'Dynamic Head Tracking',
        'Force Sensor',
        'Up to 5 hours of listening time on one charge',
        'Up to 30 hours of listening time with charging case',
      ],
    },
  },
  {
    id: 3,
    title: 'AirPods Max ',
    productImage: AirPodsMax,
    images: [
      AirPodsMaxBlue,
      AirPodsMaxPurple,
      AirPodsMaxStarlight,
      AirPodsMaxOrange,
      AirPodsMaxMidnight,
    ],
    originalPrice: ' 59,900',
    discountedPrice: '59,900',
    // offerText: 'Flat ₹2,901 off',
    colors: ['Midnight', 'Starlight', 'Blue', 'Purple', 'Orange'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' No Cost EMI from ₹2,734/month' },
    ],
    specifications: {
      // Audio: 'Active Noise Cancellation, Adaptive Transparency',
      // Battery: 'Up to 6 hours of listening time (30 hours with case)',
      // Controls: 'Touch control for volume, play/pause, and calls',
      // Compatibility: 'Works with iOS, macOS, iPadOS',
      Specs: [
        'H1 Chip',
        'Active Noise Cancellation, Adaptive Audio and Transparency mode.',
        'Personalised Spatial Audio',
        'Dynamic Head Tracking',
        'Lossless Audio via USB-C',
        'Up to 20 hours of listening time on one charge',
      ],
    },
  },
];
